import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import WhyChooseUs from "../components/WhyChooseUs";
import Footer from "../components/Footer";

const LandingPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="landing-page" style={{ opacity: isVisible ? 1 : 0, transition: "opacity 0.5s ease" }}>
      <Header />
      <Hero />
      <WhyChooseUs />
      <Footer />
    </div>
  );
};

export default LandingPage;
